import React, { useState } from "react";
import {
  Drawer,
  List,
  ListItem,
  ListItemText,
  Collapse,
  IconButton,
  Stack,
  FormControlLabel,
  Checkbox,
  Button,
  InputLabel,
  CircularProgress,
  Snackbar,
  Alert,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import ExpandLessIcon from "@mui/icons-material/ExpandMore";
import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
} from "@mui/material";

import ArrowRightIcon from "@mui/icons-material/ChevronRight";

import { makeStyles } from "@mui/styles";
import styled from "styled-components";
import BootstrapTextField from "../../../../components/TextInput";
import { PhoneInput } from "react-international-phone";
import "react-international-phone/style.css";
import { ASSETS } from "../../../../utils/config";
import { colors } from "../../../../utils";
import { QRCodeSVG } from "qrcode.react";
import { useSignup } from "../../../../services/mutations";
import WorkLifeBalanceComponent from "./ShareWheelComponent";
const Logo = styled.img`
  height: 12vh;
  width: 12vw;
`;

const useStyles = makeStyles((theme) => ({
  paper: {
    width: "100%",
    height: "100%",
    padding: 10,
    backgroundColor: "#F6F7F9",
  },
  listItemText: {
    fontWeight: 500,
    fontSize: "16px",
    lineHeight: "20px",
    color: "#123051",
  },
}));

//requred from backend
function mapRolesToNumbers(roles) {
  const roleMapping = {
    foundingAmbassador: 1,
    investor: 2,
    corporatePartner: 3,
  };

  const selectedRoles = [];

  for (const [role, isSelected] of Object.entries(roles)) {
    if (isSelected) {
      selectedRoles.push(roleMapping[role]);
    }
  }

  return selectedRoles;
}

function Sidebar({
  open = false,
  onClose,
  referral_code = "",
  authorProfile,
  wheel_name = "",
  isProfile = false,
}) {
  const classes = useStyles();
  const [expanded, setExpanded] = useState(false);
  const [shareWheelexpanded, setShareWheelExpanded] = useState(false);
  const [dialogOpen, setDialogOpen] = useState(false);

  const [formValues, setFormValues] = useState({
    firstName: "",
    email: "",
    phoneNumber: "",
    lastName: "",
    company: "", // Optional field
    roles: {
      foundingAmbassador: false,
      investor: false,
      corporatePartner: false,
    },
  });

  const [snackbarOpen, setSnackbarOpen] = useState(false);
  const [snackbarSuccessOpen, setSnackbarSuccessOpen] = useState(false);
  const [snackbarMessage, setSnackbarMessage] = useState("");

  const handleCloseSnackbar = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }
    setSnackbarSuccessOpen(false);
  };

  const toggleForm = () => {
    setExpanded(!expanded);
    setShareWheelExpanded(false);
  };

  const toggleShareWheel = () => {
    setShareWheelExpanded(!shareWheelexpanded);
    setExpanded(false);
  };

  const handleInputChange = (event) => {
    const { name, value } = event.target;
    setFormValues({ ...formValues, [name]: value });
  };

  const handleCheckboxChange = (event) => {
    const { name, checked } = event.target;
    setFormValues({
      ...formValues,
      roles: { ...formValues.roles, [name]: checked },
    });
  };

  const [errors, setErrors] = useState({}); // State to track form errors

  const validate = () => {
    let tempErrors = {};
    let errorMessage = "";
    let isValid = true;

    if (!formValues.firstName) {
      tempErrors.firstName = "First name is required";
      errorMessage = "First name is required";
      isValid = false;
    }
    if (!formValues.lastName) {
      tempErrors.firstName = "Last name is required";
      errorMessage = "Last name is required";
      isValid = false;
    }

    if (!formValues.email) {
      tempErrors.email = "Email is required";
      errorMessage = errorMessage ? errorMessage : "Email is required";
      isValid = false;
    } else if (!formValues.email.includes("@")) {
      tempErrors.email = "Email is not valid";
      errorMessage = errorMessage ? errorMessage : "Email is not valid";
      isValid = false;
    }

    setErrors({ ...tempErrors });

    if (!isValid) {
      setSnackbarMessage(errorMessage);
      setSnackbarOpen(true);
    }

    return isValid;
  };

  const signupCall = useSignup();

  const redirectToCalendly = () => {
    const { firstName, lastName, email, phoneNumber, company } = formValues;

    // Construct the Calendly URL with query parameters
    const calendlyUrl = new URL(
      "https://calendly.com/iyugawheel/presentation/"
    );
    // calendlyUrl.searchParams.set("month", "2024-02");
    calendlyUrl.searchParams.set("first_name", firstName);
    calendlyUrl.searchParams.set("last_name", lastName);
    calendlyUrl.searchParams.set("email", email);
    // calendlyUrl.searchParams.set("a1", phoneNumber.replace("+", "")); // Remove '+' from phone number if needed
    // Assuming 'a2' is a boolean value you want to set, replace 'true' with the actual condition/value
    calendlyUrl.searchParams.set("a2", company);
    calendlyUrl.searchParams.set("a3", "1");

    console.log();
    // Redirect to the constructed Calendly URL
    window.location.href = calendlyUrl.href;
    // window.open(calendlyUrl.href, "_blank");
  };

  const handleScheduleMeeting = (event) => {
    const { name, email, phoneNumber, roles, firstName, lastName, company } =
      formValues;
    if (signupCall.isLoading) {
      return false;
    }
    event?.preventDefault();
    if (validate()) {
      const username = email?.split("@")[0];
      const checkboxes =
        mapRolesToNumbers(roles)?.length === 0 ? [0] : mapRolesToNumbers(roles);
      const newUser = {
        email,
        username,
        password: "ASDdhruv23@", // Fixed password
        first_name: firstName,
        last_name: lastName, // Default to empty string if no last name
        phone_number: phoneNumber.replace("+", ""), // Remove '+' from the phone number
        country_code: phoneNumber.slice(0, phoneNumber.length - 10),
        is_waiting_list: true,
        company: company,
        beta_user_type: checkboxes, // Founding Ambassador and Investor
        referral_code: referral_code,
      };

      signupCall.mutate(newUser, {
        onSuccess: () => {
          redirectToCalendly();
          setSnackbarSuccessOpen(true); // Open the dialog on success
          // setDialogOpen(true); // Open the dialog on success
          setFormValues({
            firstName: "",
            email: "",
            phoneNumber: "",
            lastName: "",
            company: "",
            roles: {
              foundingAmbassador: false,
              investor: false,
              corporatePartner: false,
            },
          });
        },
        onError: (error) => {
          if (error.response && error.response.status === 400) {
            let errorMessage = "Validation error:\n";
            const errors = error.response.data; // Assuming `data` contains the validation errors
            for (const key in errors) {
              errorMessage += `${key}: ${errors[key].join(", ")}\n`;
            }
            alert(errorMessage);
          } else {
            // Handle other types of errors
            alert("An error occurred. Please try again later.");
          }
        },
      });
    }
  };

  const handlePhoneNumberChange = (value) => {
    setFormValues({ ...formValues, phoneNumber: value });
  };

  return (
    <Drawer
      classes={{ paper: classes.paper }}
      variant="persistent"
      sx={{ backgroundColor: "red" }}
      ModalProps={{ keepMounted: true }}
      anchor="right"
      open={open}
      onClose={onClose}
    >
      <div>
        <Snackbar
          open={snackbarOpen}
          autoHideDuration={6000}
          onClose={() => setSnackbarOpen(false)}
        >
          <Alert
            onClose={() => setSnackbarOpen(false)}
            severity="error"
            sx={{ width: "100%" }}
          >
            {snackbarMessage}
          </Alert>
        </Snackbar>

        <Snackbar
          open={snackbarSuccessOpen}
          autoHideDuration={6000}
          onClose={handleCloseSnackbar}
        >
          <Alert
            onClose={handleCloseSnackbar}
            severity="success"
            sx={{ width: "100%" }}
          >
            Thank you for signing up.
          </Alert>
        </Snackbar>

        <Stack
          direction="row"
          justifyContent="space-between"
          alignItems="center"
          sx={{ width: "100%", padding: "0 16px" }}
        >
          <Logo alt="logo" src={ASSETS.MobileLogo} />
          <IconButton
            size="small"
            style={{ backgroundColor: colors.primary, color: colors.white }}
            onClick={onClose}
            edge="end"
            aria-label="close"
          >
            <CloseIcon />
          </IconButton>
        </Stack>
        <List>
          <ListItem button onClick={toggleForm}>
            <ListItemText
              classes={{ primary: classes.listItemText }}
              primary="Enter Beta Waitlist"
            />
            <IconButton
              edge="end"
              onClick={toggleForm}
              aria-label="toggle waitlist form"
            >
              {expanded ? <ExpandLessIcon /> : <ArrowRightIcon />}
            </IconButton>
          </ListItem>
          <Collapse in={expanded} timeout="auto" unmountOnExit>
            <List component="div" disablePadding>
              <ListItem>
                <Stack spacing={2} direction={"row"}>
                  <BootstrapTextField
                    label="First Name"
                    name="firstName"
                    value={formValues.firstName}
                    onChange={handleInputChange}
                    required
                    placeholder="First name"
                  />

                  <BootstrapTextField
                    label="Last Name"
                    name="lastName"
                    value={formValues.lastName}
                    onChange={handleInputChange}
                    required
                    placeholder="Last name"
                  />
                </Stack>
              </ListItem>
              <ListItem>
                <BootstrapTextField
                  label="Email"
                  name="email"
                  placeholder="Email"
                  value={formValues.email}
                  onChange={handleInputChange}
                />
              </ListItem>
              <ListItem>
                <Stack style={{ width: "100%" }}>
                  <InputLabel shrink>{"Phone Number"}</InputLabel>
                  <PhoneInput
                    style={{ width: "100%" }}
                    inputStyle={{ width: "100%" }}
                    defaultCountry="us"
                    placeholder="+1 (555) 555-1234"
                    value={formValues.phoneNumber}
                    onChange={handlePhoneNumberChange}
                  />
                </Stack>
              </ListItem>
              <ListItem>
                <BootstrapTextField
                  label="Company (Optional)"
                  name="company"
                  value={formValues.company}
                  onChange={handleInputChange}
                  placeholder="Company"
                />
              </ListItem>
              <ListItem>
                <Stack spacing={0}>
                  {Object.keys(formValues.roles).map((role) => (
                    <FormControlLabel
                      key={role}
                      sx={{
                        // Apply styles to the label
                        ".MuiFormControlLabel-label": {
                          color: "#565556",
                          fontSize: 14,
                          fontWeight: "400", // Replace 'desiredColor' with the color code you want
                        },
                      }}
                      control={
                        <Checkbox
                          sx={{
                            color: colors.primary, // Color when unchecked
                            "&.Mui-checked": {
                              color: colors.primary, // Use your desired color for when the checkbox is checked
                            },
                          }}
                          checked={formValues.roles[role]}
                          onChange={handleCheckboxChange}
                          name={role}
                        />
                      }
                      label={
                        role.charAt(0).toUpperCase() +
                        role
                          .slice(1)
                          .replace(/([A-Z])/g, " $1")
                          .trim()
                      }
                    />
                  ))}
                </Stack>
              </ListItem>
              <ListItem>
                <Button
                  fullWidth
                  size="large"
                  sx={{ backgroundColor: colors.primary, width: "100%" }}
                  variant="contained"
                  color="primary"
                  onClick={handleScheduleMeeting}
                >
                  {signupCall.isLoading ? (
                    <CircularProgress size={24} color="inherit" />
                  ) : (
                    "Sign Up"
                  )}
                </Button>
              </ListItem>
            </List>
          </Collapse>

          <ListItem button onClick={toggleShareWheel}>
            <ListItemText
              classes={{ primary: classes.listItemText }}
              primary={isProfile ? "Share Gallery" : "Share the wheel"}
            />
            <IconButton
              edge="end"
              onClick={toggleForm}
              aria-label="toggle waitlist form"
            >
              {shareWheelexpanded ? <ExpandLessIcon /> : <ArrowRightIcon />}
            </IconButton>
          </ListItem>
          <Collapse in={shareWheelexpanded} timeout="auto" unmountOnExit>
            <List component="div" disablePadding>
              <ListItem sx={{ justifyContent: "center" }}>
                <div
                  style={{
                    backgroundColor: "white",
                    padding: 20,
                    alignSelf: "center",
                    border: "1px solid #E1E1E1",
                  }}
                >
                  <QRCodeSVG value={window.location.href} />
                </div>
              </ListItem>
              <ListItem sx={{ justifyContent: "center" }}>
                {
                  <WorkLifeBalanceComponent
                    isProfile={isProfile}
                    wheelName={wheel_name}
                    AuthorProfile={
                      authorProfile?.profile_image
                      // "https://cdn.pixabay.com/photo/2015/10/05/22/37/blank-profile-picture-973460_1280.png"
                    }
                    authorName={
                      authorProfile?.first_name + " " + authorProfile?.last_name
                    }
                  ></WorkLifeBalanceComponent>
                }
              </ListItem>
            </List>
          </Collapse>
        </List>
        {/* <Dialog
          open={dialogOpen}
          onClose={() => setDialogOpen(false)}
          aria-labelledby="alert-dialog-title"
          aria-describedby="alert-dialog-description"
        >
          <DialogTitle id="alert-dialog-title">
            {"Signup Successful"}
          </DialogTitle>
          <DialogContent>
            <DialogContentText id="alert-dialog-description">
              Thank you for signing up. We will reach out shortly.
            </DialogContentText>
          </DialogContent>
          <DialogActions>
            <Button onClick={() => setDialogOpen(false)} color="primary">
              Close
            </Button>
            <Button
              onClick={() => {
                setDialogOpen(false); // Optionally close the dialog first
                redirectToCalendly(); // Redirect the user
              }}
              color="primary"
              autoFocus
            >
              Schedule Meeting
            </Button>
          </DialogActions>
        </Dialog> */}
      </div>
    </Drawer>
  );
}

export default Sidebar;
